<template>
  <NuxtLayout
    name="generic"
    :header="data?.header"
    :footer="data?.footer"
  >
    <div
      :class="{
        'flex flex-col pt-80px md:pt-120px xl:min-h-screen xl:flex-row': true,
      }"
    >
      <LeftSideNav
        v-if="data"
        :left-side-nav-data="data.leftSideNav"
      />
      <main
        :class="{
          'grid-12 ml-10 mr-10 grid gap-x-8': true,
        }"
      >
        <div
          :class="{
            'col-span-12 xl:col-span-9': true,
          }"
        >
          <ColumnsCardsSection
            :columns="[
              {
                title: data?.firstColumnTitle,
                description: data?.firstColumnDescription,
                cards: data?.firstColumnCards,
              },
              {
                title: data?.secondColumnTitle,
                description: data?.secondColumnDescription,
                cards: data?.secondColumnCards,
              },
            ]"
          />
        </div>
        <div
          :class="{
            'col-span-12 xl:col-span-3': true,
          }"
        >
          <LinksGroup
            v-if="data"
            :links-group-data="data.linksGroup"
          />
        </div>
        <div
          :class="{
            'col-span-12': true,
          }"
        >
          <PersonalizedSectionBuilder
            v-if="latestNewsPersonalizedSectionBuilder"
            :data="latestNewsPersonalizedSectionBuilder"
            component-type="latestNews"
            :class="{
              'pt-5 text-center xl:text-left': true,
            }"
          />
        </div>
      </main>

      <section
        :class="{
          'container w-full xl:hidden': true,
        }"
      >
        <div
          :class="{
            'flex justify-center gap-1 pl-4 pt-6 align-middle': true,
          }"
        >
          <SocialIcon
            v-for="(icon, index) in data?.socialMediaIcons"
            :key="index"
            v-bind="icon"
            :class="{ 'max-h-14 max-w-14 transition duration-300 hover:brightness-75': true }"
          />
        </div>
      </section>
    </div>
  </NuxtLayout>
</template>

<script lang="ts" setup>
import { customerHomeQuery } from '~/queries/pages/PageCustomerHome.query';
import type { CustomerHomeQueryResult } from '~/sanity/types';
import LeftSideNav from '~/components/Organisms/customerHome/LeftSideNav.vue';
import ColumnsCardsSection from '~/components/Organisms/customerHome/ColumnsCardsSection.vue';
import LinksGroup from '~/components/Organisms/customerHome/LinksGroup.vue';
import PersonalizedSectionBuilder from '~/components/Atmos/PersonalizedSectionBuilder/PersonalizedSectionBuilder.vue';
import SocialIcon from '~/components/Atmos/SocialIcon/SocialIcon.vue';

const { getResolvedPersonalizedSectionBuilder } = useRefsStore();
usePersonalization(); // this will make the call to crossSession
const { path: currentPathname } = useRoute();
const { data } = await useWwwSanityQueryNonNull<CustomerHomeQueryResult>(customerHomeQuery, {
  currentPathname,
});

usePageHead({
  _id: data.value?._id,
  description: data.value?.ogDescription || data.value?.description,
  ogImage:
    data.value?.ogImage?.asset ||
    data.value?.cardImage?.asset ||
    data.value?.genericCardImage?.asset,
  title: data.value?.htmlTitle || data.value?.title,
  excludeFromExternalSearch: data.value?.excludeFromExternalSearch,
  twitterCard: 'summary',
});
const latestNewsPersonalizedSectionBuilder = await getResolvedPersonalizedSectionBuilder(
  data.value?.customerLatestNewsPersonalizedSectionBuilder?.reference?._ref
);
</script>
<style>
.sign-in-message a {
  text-decoration: none !important;
}
.sign-in-message p {
  font-size: 14px !important;
  line-height: 1rem !important;
}
</style>
